import React from "react";
import { useParams, Link } from "react-router-dom";
import { projectsData } from "../data/data";
import { motion } from "framer-motion";

function ProjectGallery() {
  const { projectId } = useParams();

  // نجيب المشروع من كل البلاد
  let project = null;
  for (let country of Object.values(projectsData)) {
    if (country.projects[projectId]) {
      project = country.projects[projectId];
      break;
    }
  }

  if (!project) return <p>Project not found</p>;

  return (
    <div className="container mx-auto px-6 py-16">
      <Link
        to="/#projects"
        className="inline-block mb-6 px-4 py-2 bg-black text-white border-2 border-white rounded hover:bg-gray-300"
      >
        ⬅ Back to Projects
      </Link>

      <h2 className="text-3xl font-bold mb-6 underline decoration-gray-300 underline-offset-4 pb-2 w-fit">
        {project.name}
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {project.images.map((src, i) => (
          <motion.img
            key={i}
            src={src}
            alt={`${project.name} ${i + 1}`}
            className="w-full h-64 object-cover rounded-lg shadow"
            initial={{ opacity: 0, scale: 0.9, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: i * 0.1,
              ease: "easeOut",
            }}
            viewport={{ once: true, amount: 0.2 }}
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectGallery;
